import { useCallback, useMemo } from 'react'

import { customerioTracker } from 'lib'
import { ZAI_CHAT_PARAMS_KEY } from 'modules/zai/common/zai.consts'
import { zaiUtils } from 'modules/zai/common/zai.utils'

import { PROMPT_ORDER_BY_USE_CASE } from './zai-hero.consts'
import type { KnownPrePromptId, TZaiHeroModel } from './zai-hero.types'

export const useZaiHeroModel: TZaiHeroModel = ({ baseUrl, prePromptsData, routerHistoryPush, userZaiPreference }) => {
  const prePromptList = useMemo(() => {
    const mappedList = prePromptsData.map(prePrompt => {
      const variant = zaiUtils.transformPrePromptKeyToVariant(prePrompt.variant?.key, 'purple')
      const queryParams = new URLSearchParams({
        [ZAI_CHAT_PARAMS_KEY.threadPrompt]: prePrompt.text,
        [ZAI_CHAT_PARAMS_KEY.threadPromptPage]: 'Home',
        [ZAI_CHAT_PARAMS_KEY.quickPromptId]: String(prePrompt.id),
      })
      if (prePrompt.variant?.key) {
        queryParams.set(ZAI_CHAT_PARAMS_KEY.promptVariant, prePrompt.variant.key)
      }
      const url = `${baseUrl}?${queryParams.toString()}`

      return {
        ...prePrompt,
        url,
        variant,
      }
    })

    const orderForPreference = userZaiPreference ? PROMPT_ORDER_BY_USE_CASE[userZaiPreference] : undefined

    if (orderForPreference) {
      mappedList.sort((a, b) => {
        const rankA = orderForPreference.indexOf(a.id as KnownPrePromptId)
        const rankB = orderForPreference.indexOf(b.id as KnownPrePromptId)
        return (rankA === -1 ? orderForPreference.length : rankA) - (rankB === -1 ? orderForPreference.length : rankB)
      })
    }

    return mappedList
  }, [baseUrl, prePromptsData, userZaiPreference])

  const formOnSubmit = useCallback(
    event => {
      const form = new FormData(event.currentTarget)
      const prePromptText = (form.get('pre-prompt-text') as string).trim()

      if (!prePromptText) return

      customerioTracker.track(customerioTracker.eventNames.FEATURE_USED, {
        feature: 'zai',
        action: 'send_message',
      })

      routerHistoryPush(
        `${baseUrl}?${ZAI_CHAT_PARAMS_KEY.threadPrompt}=${prePromptText}&${ZAI_CHAT_PARAMS_KEY.threadPromptPage}=Home`
      )
    },
    [baseUrl, routerHistoryPush]
  )

  return {
    formOnSubmit,
    prePromptList,
  }
}
